import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import AuthenticationForm from './components/auth/AuthenticationForm';
import JobListings from './components/jobs/JobListings';
import MessagingSystem from './components/messaging/MessagingSystem';
import Navbar from './components/navbar';
import './App.css';
import './styles/globals.css';  // Adjust path as needed
import CreateJob from './components/jobs/CreateJob';
import ProfilePage from './pages/profile';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import LandingPage from './pages/LandingPage';

// Loading Spinner Component
const LoadingSpinner = () => (
  <div className="flex justify-center items-center">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
  </div>
);

// Error Message Component
const ErrorMessage = ({ message }) => (
  <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
    {message}
  </div>
);

function App() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Global error handler
  const handleError = (error) => {
    setError(error.message);
    setTimeout(() => setError(null), 5000); // Clear error after 5 seconds
  };

  // Add theme provider state
  useEffect(() => {
    // Check system preference and localStorage
    const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    const savedTheme = localStorage.getItem('theme');
    const initialDarkMode = savedTheme ? savedTheme === 'dark' : systemPrefersDark;
    
    // Apply theme
    document.documentElement.classList.toggle('dark', initialDarkMode);
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-300">
          <Navbar />
          <main className="container mx-auto mt-8 px-4">
            {isLoading && <LoadingSpinner />}
            {error && <ErrorMessage message={error} />}
            
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/auth" element={<AuthenticationForm />} />
              
              {/* Protected Routes */}
              <Route path="/jobs" element={
                <ProtectedRoute>
                  <JobListings onError={handleError} setLoading={setIsLoading} />
                </ProtectedRoute>
              } />
              <Route path="/profile" element={
                <ProtectedRoute>
                  <ProfilePage onError={handleError} setLoading={setIsLoading} />
                </ProtectedRoute>
              } />
              <Route path="/messages" element={
                <ProtectedRoute>
                  <MessagingSystem onError={handleError} setLoading={setIsLoading} />
                </ProtectedRoute>
              } />
              <Route path="/post-job" element={
                <ProtectedRoute>
                  <CreateJob onError={handleError} setLoading={setIsLoading} />
                </ProtectedRoute>
              } />
              {/* Removed UserProfile route */}
            </Routes>
          </main>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;